import { WhatsappLogo } from "@phosphor-icons/react";
import { WHATSAPP_URL } from "../../lib/site";

export const WhatsappButton = () => (
  <a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float"
    aria-label="Falar no WhatsApp"
    className="group fixed bottom-6 right-6 z-50 flex items-center gap-3 rounded-full bg-[#25D366] px-4 py-4 text-white shadow-2xl transition-transform duration-300 hover:-translate-y-1 md:px-5"
  >
    <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-40" />
    <WhatsappLogo size={30} weight="fill" className="relative" />
    <span className="relative hidden font-display font-bold md:inline">Fale conosco</span>
  </a>
);
